var UAParser = require('ua-parser-js');

var parser = new UAParser(navigator.parser);
var userAgent = parser.getResult();

var Device = {
  agent: userAgent,
  browser: userAgent.browser.name.toLowerCase(),
  engine: userAgent.engine.name.toLowerCase(),
  os: userAgent.os.name.toLowerCase()
};

var mobile = ['ios', 'android', 'windows phone'];
var desktop = ['mac os', 'windows'];

Device.isDefinitelyMobile = mobile.indexOf(Device.os) !== -1;
Device.isDefinitelyDesktop = desktop.indexOf(Device.os) !== -1;

Device.isWebkit = (Device.engine == 'webkit');

Modernizr.addTest('scrollsnap', function() {
  return 'scrollSnapType' in document.documentElement.style || 'webkitScrollSnapType' in document.documentElement.style;
});

Modernizr.addTest('scrollbehavior', function() {
  return 'scrollBehavior' in document.documentElement.style || 'webkitScrollBehavior' in document.documentElement.style;
});

Modernizr.addTest('retina', function() {
  var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';

  var dpr = window.devicePixelRatio || 1;

  if(dpr > 1) {
    return true;
  }

  if(matchMedia && matchMedia(mediaQuery).matches) {
    return true;
  }

  return false;
});

Modernizr.addTest('def-desktop', function() {
  return Device.isDefinitelyDesktop;
});

Modernizr.addTest('def-mobile', function() {
  return Device.isDefinitelyMobile;
});

module.exports = Device;
